import React, { PropTypes } from 'react';
import partial from 'lodash/partial';
import ImageUploadModal from 'common/components/modal/image_upload_modal';
import classnames from 'classnames';
import DEFAULT_BACKGROUND from 'assets/images/kitten.png';
import Logo from 'assets/images/crowdspring_badge.svg';

const BACKGROUND_MIN = {
  width: 1200,
  height: 280,
};

const EditBackground = ({ profileBg, showBackgroundSelector, toggleSelect, updateBackground }) => {

  const backgroundImage = profileBg;
  const backgroundStyle = backgroundImage ? {
    backgroundImage: `url(${backgroundImage})`
  } : null;

  const changeClass = classnames('btn btn-change-bg btn-secondary');

  return (<div className="edit-background">
            <div className="profile-background-container">
              { profileBg ?
                <div className="profile-background" style={backgroundStyle}>
                  <a className={changeClass} onClick={toggleSelect}>Change</a>
                  <a className={changeClass} onClick={partial(updateBackground, '')}>Clear</a>
                </div>:
                <div className="profile-background empty edit">
                  <div className="svg-logo" dangerouslySetInnerHTML={{ __html: Logo }} />
                  <a className={changeClass} onClick={toggleSelect}>
                    Change
                  </a>
                </div>
              }
            </div>

            <ImageUploadModal
              minWidth={BACKGROUND_MIN.width}
              minHeight={BACKGROUND_MIN.height}
              maxSize={1}
              show={showBackgroundSelector}
              selectImage={updateBackground}
              toggleModal={toggleSelect}
              tips={['Use the Cover Photo to display your best work.', 'Use JPG or PNG', '1440x280 optimal dimensions', '1MB max size']}
            />
          </div>
        );
};

EditBackground.propTypes = {
  profileBg: PropTypes.string,
  updateBackground: PropTypes.func,
  toggleSelect: PropTypes.func,
  showBackgroundSelector: PropTypes.bool,
};

export default EditBackground;



// WEBPACK FOOTER //
// ./profile/components/edit_background.jsx